<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"></app-header>

    <div *ngIf="isDictionaryTooltipVisible && !wordDictionaryDetails" class="dictionary-tooltip"
      [style.left.px]="xPosition" [style.top.px]="yPosition">
      <div class="dictionary-heading">{{ "Word Not Found" | translate }}</div>
    </div>

    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper">
        <div class="title-banner-wrapper" [class.is-mobile]="isHandsetPortrait"
          [style.backgroundImage]="getBackgroundImageUrl(sectionBannerImage)" [ngClass]="txtColor">
          <h1 class="bani-title">
            <span class="main-title">{{ heirarchyCommonData?.BaniName }} </span>
            <p class="author"><span *ngFor="let author of heirarchyCommonData?.Author;let i = index;">{{
                author?.ContributorName }}<span *ngIf="i < heirarchyCommonData?.Author?.length - 1">, </span></span>
            </p>
            <!-- <p class="subtitle">{{ sectionName }} </p> -->
            <!-- {{ "Bani Details" | translate }} -->
          </h1>
        </div>
      </div>
      <div class="breadcrumbs-tools-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="breadcrumbs-wrapper">
          <span class="cursor-pointer 1" (click)="goToBaniDashboard()">
            {{ heirarchyCommonData?.BaniName }}
          </span>
          <span class="breadcrumb-to-icon">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </span>
          <span [matMenuTriggerFor]="sectionMenu" class="cursor-pointer 2">
            {{ sectionName }}
          </span>
          <span>
            <mat-icon [matMenuTriggerFor]="sectionMenu">arrow_drop_down</mat-icon>  
          </span>
          <span>
            <mat-menu yPosition="below" #sectionMenu="matMenu">
              <div *ngIf="allNavigationButtonsList?.length">
                <button *ngIf="allNavigationButtonsList[0]?.Introduction" (click)="navigateOnIntroductionPage('Introduction')" class="introduction-selectable-button"
                mat-menu-item>
                  {{ "introduction" | translate }}
                </button> 
                <button *ngIf="allNavigationButtonsList[0]?.HistoricalDimension" (click)="navigateOnIntroductionPage('HistoricalDimension')"
                  class="introduction-selectable-button" mat-menu-item>
                  {{ "historical" | translate }}
                </button>
                <button *ngIf="allNavigationButtonsList[0]?.CulturalDimension" (click)="navigateOnIntroductionPage('CulturalDimension')"
                  class="introduction-selectable-button" mat-menu-item>
                  {{ "Cultural_Dimension" | translate }}
                </button>
                <button *ngIf="allNavigationButtonsList[0]?.MusicalDimension" (click)="navigateOnIntroductionPage('MusicalDimension')"
                  class="introduction-selectable-button" mat-menu-item>
                  {{ "musical" | translate }}
                </button>
                <button *ngIf="allNavigationButtonsList[0]?.SignificantTerms" (click)="navigateOnIntroductionPage('SignificantTerms')"
                  class="introduction-selectable-button" mat-menu-item>
                  {{ "Significant_Terms" | translate }}
                </button>
              </div>
              <ng-container *ngFor="let section of sectionsList">
                <button vj (click)="handleSectionSelect(section.SectionSequence)" mat-menu-item color="primary">
                  <span> {{ section.SectionName }} </span>
                </button>
              </ng-container>
            </mat-menu>
          </span>

          <!-- Subsection Menu <ng-container *ngIf="currentSectionSequence !== 0"> -->

          <ng-container *ngIf="subSectionLength !== 1">
            <span class="breadcrumb-to-icon">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </span>

            <span [matMenuTriggerFor]="subSectionMenu" class="cursor-pointer 3">
              {{ subSectionName }}
            </span>
            <mat-icon [matMenuTriggerFor]="subSectionMenu">arrow_drop_down</mat-icon>
            <mat-menu yPosition="below" #subSectionMenu="matMenu">
              <ng-container *ngFor="let subSectionItem of activeSectionData.SubSection">
                <button (click)="
                    handleSubSectionSelect(subSectionItem.SubSectionSequence)
                  " mat-menu-item color="primary">
                  <span> {{ subSectionItem.SubSectionName }} </span>
                </button>
              </ng-container>
            </mat-menu>
          </ng-container>



        </div>
        <div class="formatting-options-wrapper">
          <span [matMenuTriggerFor]="fontMenu"> {{ "Text_Size" | translate }} </span>
          <!-- <mat-icon (click)="showFontList()"> format_size</mat-icon>
 -->
          <div class="font-wrapper">
            <mat-icon class="fnt-icon" [matMenuTriggerFor]="fontMenu"><img alt="Font Menu Resize Icon"
                src="/assets/images/font.png"> </mat-icon>
            <mat-menu class="fnt-menu" xPosition="before" #fontMenu="matMenu">
              <ul id="fontSize" class="fnt-menu-list" [class.is-mobile]="isHandsetPortrait">
                <li (click)="setFont(16)" style="font-size: 16px">16</li>
                <li (click)="setFont(18)" style="font-size: 18px">18</li>
                <li (click)="setFont(20)" style="font-size: 20px">20</li>
                <li (click)="setFont(22)" style="font-size: 22px">22</li>
                <li (click)="setFont(24)" style="font-size: 24px">24</li>
              </ul>
            </mat-menu>
            <span class="seprator">|</span>
          </div>
          <span [matMenuTriggerFor]="shareMenu"> {{ "Share" | translate }} </span>
          <div class="social-share" [class.is-mobile]="isHandsetPortrait">
            <mat-icon class="share-icon" [matMenuTriggerFor]="shareMenu"><img alt="Social Share Icon"
                src="/assets/images/share.png"> </mat-icon>
            <mat-menu class="share-menu" xPosition="before" #shareMenu="matMenu">
              <share-buttons theme="circles-dark" [include]="['copy', 'facebook','twitter', 'whatsapp']"
                [showIcon]="true" [showText]="false" url="{{shareUrl}}" twitterAccount="rodrigokamada" class="pt-5">
              </share-buttons>
            </mat-menu>
          </div>

          <!-- <mat-icon>bookmark_border</mat-icon> -->
        </div>
        <!-- <div class="tools-wrapper">
          
        </div> -->
      </div>
      <!-- Content start from here -->
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div *ngIf="isBaniSubDetailsLoading" class="details-content vj">
          <div *ngFor="let paragraph of [0, 1, 2, 4]" class="loading-paragraph animate"></div>
        </div>

        <div class="introduction-footer">
          <div class="footer-nav-buttons-wrapper" [class.is-mobile]="isHandsetPortrait">
            <button (click)="handlePrevious(!doesPreviousExist(), heirarchyCommonData.SignificantTerms)"
              class="btn-sggs">
              < {{ prevButtonText | translate }} 
            </button>
            <button (click)="handleNext()" *ngIf="doesNextExist()" class="btn-sggs">
              {{ nextButtonText | translate }} >
            </button>
          </div>
        </div>

        <div *ngIf="!isBaniSubDetailsLoading" class="details-content vj2" [style.font-size.px]="fontSize">

          <div class="baniIntro"
            [innerHTML]="isValidOverview(activeSubSectionData.SubSectionOverview)
            ? showModifiedOverview(activeSubSectionData.SubSectionOverview) 
            : isValidOverview(activeSubSectionData.Overview) ? showModifiedOverview(activeSubSectionData.Overview) : '' | highlighter:paramObj:'full'" >
            <!-- [innerHTML]="activeSubSectionData.Overview && activeSubSectionData.Overview != '\r\n\r\n' ? showModifiedOverview(activeSubSectionData.Overview) : showModifiedOverview(activeSubSectionData.SubsectionOverview) | highlighter:paramObj:'full'"> -->
            <!-- [innerHTML]="showModifiedOverview(activeSubSectionData.Overview) | highlighter:paramObj:'full'"> -->
            <!-- [innerHTML]="showModifiedOverview(activeSubSectionData.Overview) | highlighter:searchText:'full'"> -->

          </div>

          <!-- <div class="sub-section-content xx" *ngIf="activeSubsectionDetailTitle !== 'Overview'"
            [innerHTML]="subSectionTopContent | highlighter:searchText:'full'"
            [style.font-size.px]="fontSize === 24 ? 22 : fontSize === 22 ? 21 : fontSize"></div> -->
          <div class="sub-section-content xx" *ngIf="activeSubsectionDetailTitle !== 'Overview'"
            [innerHTML]="subSectionTopContent | highlighter:paramObj:'full'"
            [style.font-size.px]="fontSize === 24 ? 22 : fontSize === 22 ? 21 : fontSize"></div>

          <div *ngIf="isDictionaryTooltipVisible && wordDictionaryDetails" class="dictionary-tooltip"
            [style.left.px]="xPosition" [style.top.px]="yPosition">
            <!-- Tooltip content goes here -->
            <div class="dictionary-heading"
              [class.sudictionary-heading-special-text]="
                wordDictionaryDetails?.WordName === 'ਨਾਸ੍ਤਿ' || 
                wordDictionaryDetails?.WordName === 'ਅਸ੍ਤ'"
            >
              {{ wordDictionaryDetails?.WordName }}
            </div>
            <div *ngIf="wordDictionaryDetails?.WordMeaning" class="dictionary-detail-wrapper">
              <div class="dictionary-detail-heading">{{ "Meaning" | translate }}</div>
              <div class="dictionary-detail">
                {{ wordDictionaryDetails?.WordMeaning }}
              </div>
            </div>
           
            <div *ngIf="wordDictionaryDetails?.WordGrammar?.trim()" class="dictionary-detail-wrapper">
              <div class="dictionary-detail-heading">{{ "Grammar" | translate }}</div>
              <div class="dictionary-detail">
                {{ wordDictionaryDetails?.WordGrammar }}
              </div>
            </div>
           
            <div *ngIf="wordDictionaryDetails?.WordEtymology" class="dictionary-detail-wrapper">
              <div class="dictionary-detail-heading">{{ "Etymology" | translate }}</div>
              <div class="dictionary-detail">
                {{ wordDictionaryDetails?.WordEtymology }}
              </div>
            </div>
             <div *ngIf="wordDictionaryDetails?.WordMeaningFootnote" class="dictionary-detail-wrapper">
              <div class="dictionary-detail-heading">{{ "Footnotes" | translate }}</div>
              <div class="dictionary-detail"
                [innerHTML]="showFotNotTextHTML(wordDictionaryDetails?.WordMeaningFootnote)">

              </div>
            </div>
             <div *ngIf="wordDictionaryDetails?.WordGrammarFootnote" class="dictionary-detail-wrapper">
              <div class="dictionary-detail-heading">{{ "WordGrammar Footnotes" | translate }}</div>
              <div class="dictionary-detail"
                [innerHTML]="showFotNotTextHTML(wordDictionaryDetails?.WordGrammarFootnote)">

              </div>
            </div>
            <div *ngIf="wordDictionaryDetails?.WordEtymologyFootnote" class="dictionary-detail-wrapper">
              <div class="dictionary-detail-heading">{{ "Etymology Footnotes" | translate }}</div>
              <div class="dictionary-detail"
                [innerHTML]="showFotNotTextHTML(wordDictionaryDetails?.WordEtymologyFootnote)">

              </div>
            </div>
          </div>

          <!-- <div class="introduction-footer">
            <div class="footer-nav-buttons-wrapper" [class.is-mobile]="isHandsetPortrait">
              <button (click)="handlePrevious(!doesPreviousExist(), heirarchyCommonData.SignificantTerms)"
                class="btn-sggs">
                < {{ prevButtonText | translate }} </button>
                  <button (click)="handleNext()" *ngIf="doesNextExist()" class="btn-sggs">
                    {{ nextButtonText | translate }} >
                  </button>
            </div>
          </div> -->
          <!-- --------------------------------------------------------------------------------------------------------------------------------------------------------------------------- -->

          <div *ngIf="currentSubSectionSequence !== 1" class="introduction-param-label-wrapper show-for-mobile"
            [class.is-mobile]="isHandsetPortrait">
            <ng-container *ngFor="let baniSubsectionDetailType of baniSubsectionDetailTypes; let i = index">
              <div *ngIf="hideTypes(baniSubsectionDetailType)" class="accordion-item">
                <div class="accordion-header btn-sggs"
                  [class.active]="activeAccordionItems.has(baniSubsectionDetailType)"
                  (click)="toggleAccordion(baniSubsectionDetailType)">

                  <div>{{ baniSubsectionDetailType }}</div>
                  <span class="accordion-icon"></span>
                </div>
                <div *ngIf="activeAccordionItems.has(baniSubsectionDetailType)" class="accordion-content sub-details-content cc"
                  [class.is-mobile]="isHandsetPortrait" [innerHTML]="subSectionContentMap[baniSubsectionDetailType] | highlighter:paramObj:'full'">
                  <!-- [class.is-mobile]="isHandsetPortrait" [innerHTML]="subSectionContentMap[baniSubsectionDetailType] | highlighter:searchText:'full'"> -->
              </div>
              </div>
            </ng-container>
          </div>

          <!-- --------------------------------------------------------------------------------------------------------------------------------------------------------------------------- -->
          <div *ngIf="currentSubSectionSequence !== 1" class="introduction-param-label-wrapper hide-for-mobile"
            [class.is-mobile]="isHandsetPortrait">
            <ng-container *ngFor="let baniSubsectionDetailType of baniSubsectionDetailTypes">
              <div *ngIf="hideTypes(baniSubsectionDetailType)"
                [class.active]="activeSubsectionDetailTitle === baniSubsectionDetailType"
                class="introduction-param-label btn-sggs"
                (click)="handleSubSectionTypeSelect(baniSubsectionDetailType)">
                <span>{{ baniSubsectionDetailType }}</span>
              </div>
            </ng-container>
          </div>
          <ng-container>
            <div class="sub-details-content hide-for-mobile-d-block cc" [class.is-mobile]="isHandsetPortrait"
              [innerHTML]="htmlContent | highlighter:paramObj:'full'"></div>
              <!-- [innerHTML]="htmlContent | highlighter:searchText:'full'"></div> -->

            <div class="introduction-footer">
              <div class="footer-nav-buttons-wrapper" [class.is-mobile]="isHandsetPortrait">
                <!-- [disabled]="!doesPreviousExist()"
                 --> <button (click)="handlePrevious(!doesPreviousExist(), heirarchyCommonData.SignificantTerms)"
                  class="btn-sggs">
                  <!-- < {{ "previous" | translate }} -->
                  < {{ prevButtonText | translate }} <!-- <img
                    [src]="fetchLanguage() === 'pa' ? '/assets/images/pre-golden-pa.png' : '/assets/images/prev.png'"
                    [attr.width]="fetchLanguage() != 'pa' ? 'auto' : '70'" alt="Previous Button Image"> -->
                </button>
                <button (click)="handleNext()" *ngIf="doesNextExist()" class="btn-sggs">
                  <!-- {{ "next" | translate }} > -->
                  {{ nextButtonText | translate }} >
                  <!-- <img
                    [src]="fetchLanguage() === 'pa' ? '/assets/images/next-golden-pa.png' : '/assets/images/next-1.png'"
                    [attr.width]="fetchLanguage() != 'pa' ? 'auto' : '70'" alt="Next Button Image"> -->
                </button>
              </div>
            </div>
          </ng-container>
          <div class="container d-flex pt-4 pb-4 align-items-center">
            <span class="px-2">Tags</span>
            <div class="term-tags">
              <mat-chip-set class="example-chip px-2" cdkDropListOrientation="horizontal">
                <!-- {{activeSectionData | json }} -->
                <!-- <ng-container *ngFor="let tags of activeSectionData?.BaniDetailTags[0]"> -->
                <ng-container *ngFor="let tags of activeSectionData?.BaniDetailTags[0] | keyvalue">
                  <mat-chip class=" btn-sggs" (click)="navigateToSearch(tags)" *ngIf="tags.key != 'SabadTitle'">

                    {{tags.value}}
                    <!-- {{tags.type}} -->
                  </mat-chip>
                </ng-container>

                <ng-container *ngFor="let tags of activeSectionData?.BaniDetailTags[0]?.SabadTitle">
                  <mat-chip class=" btn-sggs" (click)="navigateToSearchSabadTitle(tags.SabadTitle)">

                    {{tags.SabadTitle}}
                    <!-- {{tags.type}} -->
                  </mat-chip>
                </ng-container>

              </mat-chip-set>
            </div>
          </div>

        </div>

        <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>